import { useState, useEffect } from 'react'
import { db, isAbortError } from '../lib/supabase'

export default function useSubmissionDetail(id) {
  const [submission, setSubmission] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (!id) return

    let cancelled = false

    const fetchData = async () => {
      setLoading(true)
      setError(null)
      try {
        const data = await db.getSubmissionById(id)
        if (!cancelled) setSubmission(data)
      } catch (err) {
        if (isAbortError(err)) return
        if (!cancelled) setError(err.message)
      } finally {
        if (!cancelled) setLoading(false)
      }
    }

    fetchData()
    return () => { cancelled = true }
  }, [id])

  return { submission, loading, error }
}
